import Swiper from 'swiper';
import { FreeMode } from 'swiper/modules';

function initSwiper(swiperElement) {
  const swiper = new Swiper(swiperElement, {
    modules: [FreeMode],
    freeMode: true,
    spaceBetween: 24,
    slidesPerView: 'auto',
    centeredSlides: true,
    watchSlidesProgress: true,
  });
  return swiper;
}

function initTimeline(parent) {
  const mobileSwiper = initSwiper(parent);

  const months = [...parent.querySelectorAll('.mobile-timeline__month')];

  const selectMonth = (newMonth) => {
    months.forEach((month) => {
      if (month === newMonth) {
        month.classList.add('is-active');
      } else {
        month.classList.remove('is-active');
      }
    });

    const idx = months.indexOf(newMonth);
    if (idx !== -1) {
      mobileSwiper.slideTo(idx);
    }
  };

  months.forEach((month) => {
    month.addEventListener('click', () => selectMonth(month));
  });
}

export function mobileTimeline(selector = '.mobile-timeline') {
  document.querySelectorAll(selector).forEach((element) => initTimeline(element));
}
